import React, {Fragment} from 'react';
import Icon from "./Icon";
import moment from "moment";
import 'moment/locale/fr';


class SubControls extends React.Component {
    constructor(props) {
        super(props);
        const momentFr = moment().locale('fr');
        this.month = momentFr.localeData().months();
        this.year = new Date().getFullYear();
        this.currentMonth = new Date().getMonth() + 1;
        this.listYears = this.createYearList();

        this.handleChangePeriodIndex = this.handleChangePeriodIndex.bind(this);
        this.createYearList = this.createYearList.bind(this);
        this.handleChangeYear = this.handleChangeYear.bind(this);
        this.handleChangeMonth = this.handleChangeMonth.bind(this);
    }

    handleChangePeriodIndex(value) {
        this.props.handlePeriod(value, parseInt(this.props.currentYear), parseInt(this.props.currentMonth))
    }

    handleChangeYear(value) {
        this.props.handlePeriod(this.props.period, parseInt(value), parseInt(this.props.currentMonth))
    }

    handleChangeMonth(value) {
        this.props.handlePeriod(this.props.period, parseInt(this.props.currentYear), parseInt(value))
    }

    createYearList() {
        let years = [];
        for (let year = 1999; year <= this.year; year++) {
            years.push({year})
        }
        return years;
    }

    render() {
        return (
            <div className="sub-controls-row">
                {/*this.props.isVideo ? (
                    <h3>
                        <span className={this.props.period === 1 ? 'active' : ''}
                              onClick={() => this.handleChangePeriodIndex(1)}>Derniers 7 jours</span>
                        <span className={this.props.period === 2 ? 'active' : ''}
                              onClick={() => this.handleChangePeriodIndex(2)}>Derniers 30 jours</span>
                        <span className={this.props.period === 3 ? 'active' : ''}
                              onClick={() => this.handleChangePeriodIndex(3)}>personnalisé</span>
                    </h3>
                ) : (
                    <h3>
                        <span className={this.props.period === 0 ? 'active' : ''}
                              onClick={() => this.handleChangePeriodIndex(0)}>Dernières 24h</span>
                        <span className={this.props.period === 1 ? 'active' : ''}
                              onClick={() => this.handleChangePeriodIndex(1)}>Derniers 7 jours</span>
                        <span className={this.props.period === 2 ? 'active' : ''}
                              onClick={() => this.handleChangePeriodIndex(2)}>Derniers 30 jours</span>
                        <span className={this.props.period === 3 ? 'active' : ''}
                              onClick={() => this.handleChangePeriodIndex(3)}>personnalisé</span>
                    </h3>
                )*/}
                <h3>
                        <span className={this.props.period === 0 ? 'active' : ''}
                              onClick={() => this.handleChangePeriodIndex(0)}>Dernières 24h</span>
                    <span className={this.props.period === 1 ? 'active' : ''}
                          onClick={() => this.handleChangePeriodIndex(1)}>Derniers 7 jours</span>
                    <span className={this.props.period === 2 ? 'active' : ''}
                          onClick={() => this.handleChangePeriodIndex(2)}>Derniers 30 jours</span>
                    <span className={this.props.period === 3 ? 'active' : ''}
                          onClick={() => this.handleChangePeriodIndex(3)}>personnalisé</span>
                </h3>

                {this.props.period === 3 && (
                    <Fragment>
                        <div className="select-wrapper">
                            <select value={this.props.currentMonth}
                                    onChange={(event) => this.handleChangeMonth(event.target.value)}>
                                {this.month.map((month, index) => (
                                    <option key={index} value={(index + 1)}>{month}</option>
                                ))}
                            </select>
                            <Icon type="chevron-down"/>
                        </div>
                        <div className="select-wrapper">
                            <select value={this.props.currentYear}
                                    onChange={(event) => this.handleChangeYear(event.target.value)}>
                                {this.listYears.map((year, index) => (
                                    <option key={index} value={year.year}>{year.year}</option>
                                ))}
                            </select>
                            <Icon type="chevron-down"/>
                        </div>
                    </Fragment>
                )}
            </div>
        )
    }
}

export default SubControls;